export default "__VITE_ASSET__46da51af__"